// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PerksPage__perksContainer___2VG1i{padding:0 24px 128px}@media (max-width:719px){.PerksPage__perksContainer___2VG1i{padding:0 24px 80px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"perksContainer": "PerksPage__perksContainer___2VG1i"
};
module.exports = ___CSS_LOADER_EXPORT___;
